import { render, staticRenderFns } from "./moveComponent.vue?vue&type=template&id=41799dff&scoped=true"
import script from "./moveComponent.vue?vue&type=script&lang=js"
export * from "./moveComponent.vue?vue&type=script&lang=js"
import style0 from "./moveComponent.vue?vue&type=style&index=0&id=41799dff&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41799dff",
  null
  
)

export default component.exports